import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { StagingSlider } from "@/components/landing/StagingSlider";
import { FeatureGrid } from "@/components/landing/FeatureGrid";
import { ProductTabs } from "@/components/landing/ProductTabs";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { AiAgents } from "@/components/landing/AiAgents";
import { VirtualTeam } from "@/components/landing/VirtualTeam";
import { Tour360 } from "@/components/landing/Tour360";
import { Integrations } from "@/components/landing/Integrations";
import { RoiCalculator } from "@/components/landing/RoiCalculator";
import { Marquee } from "@/components/landing/Marquee";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { DemoModal } from "@/components/landing/DemoModal";
import { Reveal } from "@/components/landing/Reveal";
import { ClusterSubnav } from "@/components/landing/ClusterSubnav";

export default function FeaturesPage() {
  const [demoOpen, setDemoOpen] = useState(false);
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace(/^#/, ""));
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 240); return; }
    }
    window.scrollTo(0, 0);
  }, [hash]);
  return (
    <div className="min-h-screen bg-bone" data-testid="features-page">
      <Navbar />
      <ClusterSubnav />
      <main className="pt-28 md:pt-32">
        <section className="mx-auto max-w-[1200px] px-5 sm:px-8 pb-16">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">Features</p>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-ink max-w-4xl">
              Everything the concierge can do <span className="italic text-coral">for you.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base md:text-lg text-ink/65 leading-relaxed">
              From empty rooms to launched campaigns to scored leads — here's every system the concierge is quietly driving in the background of one chat.
            </p>
          </Reveal>
        </section>

        <Marquee />
        <StagingSlider />
        <FeatureGrid />
        <ProductTabs />
        <HowItWorks />
        <VirtualTeam />
        <AiAgents />
        <Tour360 />
        <Integrations />
        <RoiCalculator />
        <FinalCTA />
      </main>
      <Footer />
      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
